// Arabic (العربية). Keys are the English source strings. Brand names stay English.
export const ar = {
  "Log in": "تسجيل الدخول",
  "Log out": "تسجيل الخروج",
  "Admin": "المشرف",
  "Continue": "متابعة",
  "Retry": "إعادة المحاولة",
  "Back": "رجوع",
  "Back to browse": "العودة للتصفّح",

  "Admin access.": "دخول المشرف.",
  "Email": "البريد الإلكتروني",
  "Password": "كلمة المرور",
  "Logging in…": "جارٍ تسجيل الدخول…",
  "Not an admin?": "لست مشرفًا؟",
  "Enter with your access code": "ادخل برمز الوصول الخاص بك",

  "Private preview. Your access code opens the loop.":
    "معاينة خاصة. رمز الوصول الخاص بك يفتح الحلقة.",
  "Access code": "رمز الوصول",
  "Entering…": "جارٍ الدخول…",
  "Enter Algorhythmic": "ادخل إلى Algorhythmic",
  "Your email": "بريدك الإلكتروني",
  "Sending…": "جارٍ الإرسال…",
  "Request access": "طلب الوصول",
  "You're on the list.": "أنت الآن على القائمة.",
  "We'll get back to you soon with your access code at {{email}}.":
    "سنرسل لك رمز الوصول قريبًا على {{email}}.",
  "Back to sign in": "العودة لتسجيل الدخول",
  "Don't have an access code?": "ليس لديك رمز وصول؟",
  "Request access code": "اطلب رمز وصول",
  "Admin login": "دخول المشرف",
  "Could not reach the server. Check your connection and try again.":
    "تعذّر الوصول إلى الخادم. تحقّق من اتصالك وحاول مجددًا.",

  "Could not load your episodes. Check your connection, then retry.":
    "تعذّر تحميل حلقاتك. تحقّق من اتصالك ثم أعد المحاولة.",
  "Resume episode": "متابعة الحلقة",
  "Play": "تشغيل",
  "More info": "مزيد من المعلومات",
  "Continue watching": "متابعة المشاهدة",

  "Could not load this series. Check your connection and try again.":
    "تعذّر تحميل هذه السلسلة. تحقّق من اتصالك وحاول مجددًا.",
  "Season": "الموسم",
  "Season 1": "الموسم 1",
  "Paused at {{time}}": "متوقّف عند {{time}}",
  "Watched": "تمّت المشاهدة",

  "Could not load this episode. Check your connection and try again.":
    "تعذّر تحميل هذه الحلقة. تحقّق من اتصالك وحاول مجددًا.",
  "You paused at {{time}}. Pick up where you left off?":
    "توقّفت عند {{time}}. أتريد المتابعة من حيث توقّفت؟",
  "Start from beginning": "البدء من البداية",

  "Quick check": "تحقّق سريع",
  "Not that one. One more try.": "ليست تلك. حاول مرّة أخرى.",
  "Talk it through with Morse. Then try once more.":
    "ناقشها مع Morse، ثم حاول مرّة أخرى.",
  "Morse has finished. Try once more.": "انتهى Morse. حاول مرّة أخرى.",
  "Correct.": "صحيح.",
  "Not quite.": "ليس تمامًا.",
  "Could not record your answer. Continue watching. This attempt won't count.":
    "تعذّر تسجيل إجابتك. تابع المشاهدة. لن تُحتسب هذه المحاولة.",

  "Playback speed": "سرعة التشغيل",
  "Quality": "الجودة",
  "Audio language": "لغة الصوت",
  "Subtitles": "الترجمة",
  "Reset quizzes for this episode": "إعادة ضبط اختبارات هذه الحلقة",
  "Normal": "عادي",
  "Off": "إيقاف",
  "More languages coming": "المزيد من اللغات قريبًا",
  "Original audio only": "الصوت الأصلي فقط",
  "No subtitles for this episode yet": "لا توجد ترجمة لهذه الحلقة بعد",
  "This will make all quizzes in this episode appear again. Continue?":
    "سيؤدي هذا إلى ظهور جميع اختبارات هذه الحلقة من جديد. هل تريد المتابعة؟",
  "Cancel": "إلغاء",

  "Language": "اللغة",

  "Try it": "جرّبها",
  "Check": "تحقّق",
  "Checking…": "جارٍ التحقّق…",
  "Take your time": "خُذ وقتك",
  "Clear": "مسح",
  "Delete": "حذف",
  "Show ladder": "أظهر السلّم",
  "Hide ladder": "أخفِ السلّم",
  "remainder": "الباقي",
  "Read the remainders from bottom to top.": "اقرأ البواقي من الأسفل إلى الأعلى.",
  "Convert": "حوّل",
  "Your answer": "إجابتك",
  "Target": "الهدف",
  "Yours": "لونك",
  "Red": "أحمر",
  "Green": "أخضر",
  "Blue": "أزرق",
  "bits": "بت",
  "Stretch task — no auto-grading yet.": "مهمة إضافية — لا تصحيح آلي بعد.",
  "Reveal solution": "أظهر الحل",
  "Hide solution": "أخفِ الحل",
  "I finished this": "أنجزت هذه",
  "All practice": "كل التدريبات",
  "Now make it yours": "اجعلها لك الآن",
  "Four quick checks, then eight problems. Nothing is timed against you.":
    "أربع فحوص سريعة، ثم ثماني مسائل. لا شيء يُحتسب ضدك بالوقت.",
  "Quick checks": "فحوص سريعة",
  "Practice problems": "مسائل تدريبية",
  "Watch the episode again": "شاهد الحلقة مرة أخرى",
  "Decimal": "عشري",
  "Tap the powers sitting under the ones.": "اضغط على القوى الواقعة تحت كل 1.",
};
